import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "button",
    "customFields",
    "customFromDate",
    "customToDate",
    "hiddenField"
  ];

  mutationObserver;

  selectedButton;

  hiddenFieldTargetConnected() {
    let previousValue;
    this.mutationObserver = new MutationObserver((mutations) => {
      if (
        mutations[0].attributeName == "value" &&
        previousValue != this.hiddenFieldTarget.value
      ) {
        previousValue = this.hiddenFieldTarget.value;
        this.handleHiddenFieldChanged();
      }
    });

    this.mutationObserver.observe(this.hiddenFieldTarget, {
      attributes: true
    });
  }

  hiddenFieldTargetDisconnected() {
    this.mutationObserver?.disconnect();
  }

  handleHiddenFieldChanged() {
    if (this.hiddenFieldTarget.value == "") {
      this.selectedButton = null;
    }
    this.optionChanged(this.hiddenFieldTarget.value);
  }

  handleButtonPressed({ currentTarget: button }) {
    const {
      dataset: { value }
    } = button;
    this.selectedButton = value;

    this.hiddenFieldTarget.value =
      this.selectedButton == "custom"
        ? this.customDateFieldsValue()
        : this.selectedButton;
  }

  optionChanged() {
    this.buttonTargets.forEach((b) => {
      if (b.dataset.value === this.selectedButton) {
        b.classList.remove("btn_outlined");
      } else {
        b.classList.add("btn_outlined");
      }
    });
    if (this.selectedButton === "custom") {
      this.customFieldsTarget.classList.remove("hidden");
      this.customFieldsTarget.querySelectorAll("input").forEach((e) => {
        e.disabled = false;
      });
    } else {
      this.customFieldsTarget.classList.add("hidden");
      this.customFieldsTarget.querySelectorAll("input").forEach((e) => {
        e.disabled = true;
      });
    }
  }

  dateChanged() {
    this.hiddenFieldTarget.value = this.customDateFieldsValue();
  }

  customDateFieldsValue() {
    const fromDate = this.customFromDateTarget.value;
    const toDate = this.customToDateTarget.value;

    return `${fromDate} to ${toDate}`;
  }
}
